module.exports = __webpack_public_path__ + "img/report_page_navigation.d673c094.png";